import { FC, useState, createContext, useEffect } from 'react';
import { getAuthToken } from 'src/api/authToken';
import { AuthResponseInterface } from 'src/models/token';

type SidebarContextType = {
  sidebarToggle: any;
  toggleSidebar: () => void;
  closeSidebar: () => void;
  selectedClientId: string;
  handleUserSelection: (userId: string) => void;
  token: string;
};

export const SidebarContext = createContext<SidebarContextType>({} as SidebarContextType);

export const SidebarProvider: FC = ({ children }) => {
  const [sidebarToggle, setSidebarToggle] = useState(false);
  // State for get token from authToken function, and then use it in sitAndStart and posPlayersSelected function
  const [token, setToken] = useState(null);
  const [error, setError] = useState('');

  const toggleSidebar = () => {
    setSidebarToggle(!sidebarToggle);
  };
  const closeSidebar = () => {
    setSidebarToggle(false);
  };

  const [selectedClientId, setselectedClientId] = useState<string>('DTC');

  const handleUserSelection = (userId: string) => {
    setselectedClientId(userId);
  };

  // Function to get token from getAuthToken function
  useEffect(() => {
    const fetchToken = async () => {
      try {
        const data = await getAuthToken();
        setToken(data);
      } catch (error) {
        setError('Request failed. Please try again.');
      }
    };

    fetchToken();
  }, []);

  return (
    <SidebarContext.Provider value={{ sidebarToggle, toggleSidebar, closeSidebar, selectedClientId, handleUserSelection, token }}>
      {children}
    </SidebarContext.Provider>
  );
};
